module.exports = __webpack_public_path__ + "de77a722/img/comments-icon.fdec7fdb.svg";